<form [formGroup]="dropDownPrepopulateForm" (ngSubmit)="saveClicked(dropDownPrepopulateForm.value)" novalidate>
    <header-bar pageTitle="Prepopulate drop down items" headingClass="fa-align-left"></header-bar>


    <div class="container mt-5">
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">Prepopulate drop down items</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm" 
                                        [disabled]="!isFormValid()">
                                    Save changes
                                    <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                
                                <div class="form-group">
                                    <label for="tbname" class="textBody--sm">Predefined list</label>
                                    <div class="dropdown position-relative">
                                        <input type="text" class="form-control" 
                                               [class.is-invalid]="showValidationError"
                                               [(ngModel)]="searchTerm"
                                               [ngModelOptions]="{standalone: true}"
                                               (ngModelChange)="onSearchChange($event)"
                                               (focus)="onInputFocus()"
                                               (blur)="onInputBlur()"
                                               (keydown)="onKeyDown($event)"
                                               placeholder="Please select"
                                               autocomplete="off">
                                        <ul class="dropdown-menu w-100 shadow-sm" 
                                            [class.show]="showDropdown"
                                            style="max-height: 200px; overflow-y: auto; position: absolute; top: 100%; left: 0; z-index: 1000;">
                                            <li *ngFor="let option of filteredListOptions">
                                                <a class="dropdown-item py-2 px-3" href="#" 
                                                   (click)="selectOption(option, $event)"
                                                   style="cursor: pointer;">
                                                    {{option.text}}
                                                </a>
                                            </li>
                                            <li *ngIf="showDropdown && filteredListOptions.length === 0" class="dropdown-item text-muted">
                                                No options found
                                            </li>
                                        </ul>
                                    </div>
                                    <div *ngIf="showValidationError" class="text-danger mt-2">
                                        <small><i class="fa fa-exclamation-triangle"></i> Please select a predefined list</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div *ngIf="selectionOptions" class="form-group">
                                <label>Select items to populate the dropdown with</label>
                                <p class="alert alert-info">
                                    {{selectAll ? 'Deselect all' : 'Select all' }} <input type="checkbox" value="false" [checked]="selectAll" (click)="selectAllItems()" />
                                </p>
                                <div class="row" [formGroup]="dropDownPrepopulateForm.controls['selections']">
                                    <div class="col col-md-4" *ngFor="let c of selectionOptions">
                                        <input type="checkbox" [formControlName]="c.value">
                                        {{ c.text }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>


<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>
